import { useQuery } from '@apollo/client'
import { getTimeSeriesData as getTimeSeriesDataGql }
   from 'src/core/graphql/queries/getTimeSeriesData.gql'

const useTimeSeriesData = (variables, options) => {
   const { data, error, fetchMore, loading, networkStatus, refetch } =
      useQuery(getTimeSeriesDataGql, {
         variables,
         notifyOnNetworkStatusChange: false,
         ...options
      })

   return {
      timeSeriesData: data?.timeSeriesData,
      error,
      fetchMore,
      loading,
      networkStatus,
      refetch
   }
}

export default useTimeSeriesData
